export const FACE_LEFT = 0;
export const FACE_RIGHT = 1;
export const FACE_FRONT = 2;
export const FACE_BACK = 3;
export const FACE_TOP = 4;

export const FACES_NAMES = {
  [FACE_BACK]: 'ATRÁS',
  [FACE_FRONT]: 'DELANTE',
  [FACE_LEFT]: 'IZQUIERDA',
  [FACE_RIGHT]: 'DERECHA',
  [FACE_TOP]: 'ARRIBA'
};

export const DEFECT_TYPE_HOLE = 0;
export const DEFECT_TYPE_MISSING_INTERLAYER = 1;
export const DEFECT_TYPE_WRINKLE = 2;
export const DEFECT_TYPE_MISSING_TAG = 3;
export const DEFECT_TYPE_MISPLACED_TAG = 4;
export const DEFECT_TYPE_MISMATCH_TAG = 5;
export const DEFECT_TYPE_FOLDED_TAG = 6;
export const DEFECT_TYPE_UNREADABLE_BARCODE = 7;
export const DEFECT_TYPE_MISSING_BLUE_BAND = 8;

export const DEFECT_TYPES_NAMES = {
  [DEFECT_TYPE_HOLE]: 'AGUJERO',
  [DEFECT_TYPE_MISSING_INTERLAYER]: 'INTERCALARIO AUSENTE',
  [DEFECT_TYPE_WRINKLE]: 'ARRUGA',
  [DEFECT_TYPE_MISSING_TAG]: 'ETIQUETA AUSENTE',
  [DEFECT_TYPE_MISPLACED_TAG]: 'ETIQUETA MAL COLOCADA',
  [DEFECT_TYPE_MISMATCH_TAG]: 'ETIQUETA INCORRECTA',
  [DEFECT_TYPE_FOLDED_TAG]: 'ETIQUETA DOBLADA',
  [DEFECT_TYPE_UNREADABLE_BARCODE]: 'CÓDIGO DE BARRAS ILEGIBLE',
  [DEFECT_TYPE_MISSING_BLUE_BAND]: 'BANDA AZUL AUSENTE'
};

// Add the IDs of defects that should be treated as secondary.
export const SECONDARY_DEFECT_TYPES = [
  DEFECT_TYPE_MISSING_TAG,
  DEFECT_TYPE_MISPLACED_TAG,
  DEFECT_TYPE_MISMATCH_TAG,
  DEFECT_TYPE_FOLDED_TAG,
  DEFECT_TYPE_UNREADABLE_BARCODE,
];

export const isSecondaryDefect = (type) => SECONDARY_DEFECT_TYPES.includes(Number(type));

export const VERALLIA_CONVEYORS = {
  1: {
    start: [80, 80],
    direction: 'down',
    width: 80,
    parts: [
      { type: 'straight', length: 220 }
    ],
    locations: [-1, -1, -1, 34, 82],
    loading: {
      side: 'right',
      length: 84
    }
  },
  2: {
    start: [80, 80],
    direction: 'down',
    width: 80,
    parts: [
      { type: 'straight', length: 220 }
    ],
    locations: [-1, -1, -1, 34, 82],
    loading: {
      side: 'left',
      length: 84
    }
  },
  3: {
    start: [80, 80],
    direction: 'down',
    width: 80,
    parts: [
      { type: 'straight', length: 220 }
    ],
    locations: [-1, -1, -1, 34, 82],
    loading: {
      side: 'right',
      length: 84
    }
  }
};